import QuestionViewVisual from "./QuestionViewVisual";
import QuestionModel from "../../maths/QuestionModel";
import QuestionInput from "../input/QuestionInput";

export default class QuestionViewVerbalShape extends QuestionViewVisual{
    constructor(question) {
        super(question);

        this.textWidth = 0;

		this.display.x = 0;
		this.display. y = 0;
		this.removeChild(this.display);

		this._bk = new PIXI.Container();
		this.addChildAt(this._bk, 0);

		this._bk.temp = new PIXI.Container();
		this._bk.addChild(this._bk.temp);

		this._populatePanel(question);

		this._bk.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 80, 60, 60, 60);
		this._bk.image.position.set(0, 0);
		//if(this.question.type === QuestionModel.TYPE_AREA_TRIANGLE) this._bk.image.position.x -= 10;
		this._bk.image.width = this._bk.temp.width + 20;
		this._bk.image.height = 250;
		this._bk.addChildAt(this._bk.image, 0);

		//this._bk.image.pivot.set(this._bk.image.width * 0.5, this._bk.image.height * 0.5);
		this._bk.image.x = -this._bk.image.width * 0.5;
		this._bk.image.y = -this._bk.image.height * 0.5;

		this._bk.position.set(0, 340);

		if(question.input === QuestionInput.INPUT_KEYPAD_RIGHT)
			this._bk.x -= 150;

		this.useUnitInAnswer = true;

		this._createNotations(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        this._question.useWords = (Math.random() < 0.5);

        if (templates && templates.length > 0)
            templates = templates.slice().filter(x => this.filterTemplate(x));

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);
        const words = data.words;

        let text = this._template ? this._template.text : "";
        if (this._template) {
            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            const items = this.generateWords(this._template.text, words.items, /\[ITEM([0-9])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
                }
            }

            const unitMatch = text.match(/\[UNIT([0-9])?]/g);
            if (unitMatch) {
                text = this._replaceUnits(text);
            }

            const defenceitem = this.generateWords(this._template.text, words.defenceitem, /\[DEFENCE([0-9])?]/g);
            for (const i in defenceitem) {
                if (defenceitem.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), defenceitem[i]);
                }
            }

            const currency = this.generateWords(this._template.text, words.currency, /\[CURRENCY([0-9])?]/g);
            for (const i in currency) {
                if (currency.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), currency[i]);
                }
            }

            const itemPairs = this.generateWords(this._template.text, words.item_pairs, /\[ITEM_PAIR([0-9])?]/g);
            for (const i in itemPairs) {
                if (itemPairs.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i)), itemPairs[i][0]);//replace first instance
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), itemPairs[i][1]);//replace the rest
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const locations = this.generateWords(this._template.text, words.locations, /\[LOCATION([0-9])?]/g);
            for (const i in locations) {
                if (locations.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }

            const match = text.match(/\. [a-z]/g);
            if (match) {
                for (let i = 0; i < match.length; ++i) {
                    const s = match[i];
                    text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
                }
            }

        }
        return text;
    }

    _replaceUnits(text){
        let unit = text.match(/\[UNIT([0-9])?]/g);

        if(unit)
            switch (this.question.type) {
                default:{
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], this.question.units[i].long);
                    break;
                }
                case QuestionModel.TYPE_MISSING_ANGLE:{
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], this.question.unit.long);
                    break;
                }
                case QuestionModel.TYPE_PERIMETER:{
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], " " + this.question.units.long);
                    break;
                }
                case QuestionModel.TYPE_COVERSION_PERCENT_OF_X:{
                    text = text.replace(unit, this.question.units[1].long);
                    break;
                }
                case QuestionModel.TYPE_COVERSION_MULTIPLICATION:{
                    text = text.replace(unit, this._question.units[this._question.units.length - 1].short);
                }
            }

        return text;
    }

	_createNotations(question){
    	let notations = question.notations;

		for (const notation in notations) {
			let t = new PIXI.Sprite(P3.assets.texture(notations[notation].texture));
			t.anchor.set(0,0.5);
			this.display.addChild(t);
		}
	}

    _populatePanel(question){
    	let t = new PIXI.Container();
		this._bk.temp.addChild(t);
		this.display.anchor.set(0, 0.5);
		this._bk.temp.addChild(this.display);
		//this._lookupPanel.image.height = 200;
		//this._lookupPanel.image.width = 200;

		let offset = 0;
		for (let i = 0; i < question.values.length - 1; i++) {
			let val = question.values[i];
			let label = new PIXI.Text(`${val.tag} = ${val.value}${question.unit.short}`, {
				fontSize: 30, fontFamily: "BBC Reith Sans", fill: 0x0, align: "center"
			});
			label.anchor.set(0, 0.5);
			label.resolution = 2;
			label.position.set(0, offset);
			t.addChild(label);
			offset += 35;
		}
		//t.y = this._bk.image.height * 0.5;
		this.textWidth = t.width;
		this.display.x += t.width + 20;
		this._bk.temp.x -= this._bk.temp.width * 0.5 - 10;
		//t.position.set(this._bk.image.width * 0.5, this._lookupPanel.image.height * 0.5 - t.height * 0.5);
	}

	initInputField() {
		super.initInputField();
		let unitLabel;
		if(this.question.type === QuestionModel.TYPE_AREA_PARALLELOGRAM || this.question.type === QuestionModel.TYPE_AREA_TRIANGLE || this.question.type === QuestionModel.TYPE_AREA_CIRCLE)
			unitLabel = new PIXI.Text(this.question.unit.short + '²', {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
		else if(this.question.type === QuestionModel.TYPE_MISSING_ANGLE){
			if(this.question.input !== 'keypad_right' && this.question.input !== 'keypad')
				unitLabel = new PIXI.Text('', {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
			else
				unitLabel = new PIXI.Text(this.question.unit.short, {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
		}
		else
			unitLabel = new PIXI.Text(this.question.unit.short, {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
		unitLabel.anchor.set(0, 0.5);
		unitLabel.resolution = 2;
		unitLabel.position.set(this._inputField.width * 0.5, 0);
		this._inputField.addChild(unitLabel);
	}

	filterTemplate(x) {
		if(this.question.type === QuestionModel.TYPE_MISSING_ANGLE){
			if(x.hasOwnProperty('difficulty'))
				return x.part === this.question.part && x.difficulty === this.question.difficulty
			else
				return x.part === this.question.part;
		}else{
			return true;
		}
	}
}